
<template>
	<div class="clearfix">
        <compWrapper title="角色基本信息" theme="primary">
			<compFormEdit :formdata="getBase" v-model="formData" ref="form" class="margin-15" :rules="rules"></compFormEdit>
		</compWrapper>
		<compWrapper title="权限菜单" theme="primary">
			<!-- <vTree
				style="overflow: auto;height: 320px;"
				@on-check-change="getPermissionIds"
				identifier="id"
				:data="authmenu"
				selection
				class="padding-10"
			></vTree> -->
            <authTable ref="authTable" :menuData="authmenu"></authTable>
		</compWrapper>
		<footer class="pull-right text-right width-100per">
			<vButton theme="primary" class="margin-right-15" @click="submit">确认</vButton>
			<vButton @click="cancel">取消</vButton>
		</footer>
		<vLoading loading size="large" fix v-if="loading"></vLoading>
	</div>
</template>

<script>
import authTable from './authTable';
import { HttpUpdateRole, HttpRoleDetail, HttpConvertRoleAlias } from '@/service/ucadm';
import { mapGetters, mapState } from 'vuex'
export default {
	props: ['params', 'type'],
	components: {
        authTable,
		compWrapper: () => import("@components/templates/wrapper"),
		compFormEdit: () => import("@components/templates/formedit"),
	},
	data() {
		return {
			permissionIds: [],
			checkIds: [],
			formData: {
				name: "",
			},
			loading: false,
			rules: {
				displayName: [{
					required: true,
					message: "该信息不能为空,请填写"
				}]
			},
		};
	},
	mounted() {
		this.getRoleDetail();
	},
	computed: {
		...mapGetters('ucadm', ['getPermenu']),
		...mapState(['userinfo']),
		isSuper() {
			return this.userinfo.isOps == 1 || this.userinfo.isSuper == 1;
		},
		isAdd() {
			return this.type === 'add'
		},
		authmenu() {
			const ids = this.checkIds || [];
			const data = this.getPermenu.map(function (item) {
				return {
					title: item.title,
					id: item.id,
					parentId: item.parentId,
					selected: ids.some(function (id) {
						return id == item.id
					})
				}
			});
			const Nodes = [];
			data.forEach(item => {
				const parentId = item.parentId;
				if (!parentId) return Nodes.push(item);
				const parent = data.find(function (item) {
					return parentId === item.id;
				});
				if (!parent) return;
				const children = parent.children;
				if (children) {
					children.push(item);
				} else {
					parent.children = [item];
				}
			});
			Nodes.forEach((item) => {
				item.expand = true;
			})
			return Nodes;
		},
		getBase() {
			return [{
				label: '名称',
				key: 'displayName',
				required: true,
				span: 24,
			}, 
            // {
			// 	label: '标识符:',
			// 	key: 'name',
			// 	span: 24,
			// 	on: {
			// 		'on-focus': this.convertRoleAlias
			// 	},
			// },
            {
				label: '是否全局角色',
				tag: "vCheckBox",
				span: 24,
				key: 'isGlobal',
				props: {
					trueValue: 1,
					falseValue: 0,
					readonly: !this.isAdd,
				},
				show: !(!this.isSuper && this.isAdd)
			}, {
				label: '描述',
				tag: "vTextarea",
				span: 24,
				key: 'description'
			}
			]
		},
	},
	methods: {
		cancel() {
			this.$emit('on-close');
		},
		getPermissionIds(val, node, checked, indeterminate) {
			this.permissionIds = [...checked, ...indeterminate];
			console.log(this.permissionIds)
		},

		async submit() {
			const vaild = await this.$refs.form.validate();
			if (!vaild) return;
			// const formData = { ...this.formData, permissionIds: this.permissionIds.join(',') };
            
			this.loading = true;
            console.log(this.$refs.authTable.selectedData);
			const formData = { ...this.formData, permissionIds: Array.from(this.$refs.authTable.selectedSet).join(',') };
			if (this.type === 'edit') formData.id = this.params;
			const response = await HttpUpdateRole(formData).catch(err => {
			    this.loading = false;
				this.$VMessage.error(err.message);
			});
			if (response) {
			    this.loading = false;
				this.$VMessage.success(response.message);
				this.$emit('on-close');
				this.$emit('on-update');
			}
		},
		async getRoleDetail() {
			if (this.type !== 'edit') return;
			this.loading = true;
			const response = await HttpRoleDetail({ id: this.params }).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			});
			if (response) {
				const { displayName, name, description } = response.data.entity || {};
				const isGlobal = response.data.isGlobal ? 1 : 0;
				this.formData = { displayName, name, description, isGlobal };
				this.checkIds = this.permissionIds = response.data.permissionIds || [];
				this.loading = false;
			}
		},

		async convertRoleAlias() {
			const { displayName, name } = this.formData
			if (!displayName || name) return;
			const response = await HttpConvertRoleAlias({ displayName }).catch(err => {
				this.$VMessage.error(err.message);
			});
			if (response) this.formData.name = response.data;
		},

	},
};
</script>
